/*
 * Global history object.
 */

import { createBrowserHistory } from 'history'

const history = createBrowserHistory()
const location = history.location

export { history, location }
export default history
